import { lazy, Suspense, useState } from 'react';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'next-i18next';
import { Button, LoadingIndicator, Modal } from '@forma/forma-ui-kit';

import styles from './social-modal.module.css';

const QRCode = lazy(() => import('react-qr-code'));

interface SocialModalProps {
  name: string,
  icon: string,
  link: string,
  viewStyle: 'primary' | 'secondary' | 'text',
  onClick?: () => void,
}

const SocialModal = ({ name, icon, link, viewStyle, onClick }: SocialModalProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        viewStyle={viewStyle}
        className={styles.button}
        icon={<ReactSVG src={icon} wrapper="span" />}
        onClick={() => {
          setOpen(true);
          if (onClick) onClick();
        }}
        size="m"
      >
        {t('write_in', { platform: name })}
      </Button>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        width="437px"
        titleClassName={styles.modalTitle}
        contentClassName={styles.modalContent}
        title="Нажмите, чтобы открыть чат"
      >
        <Button
          as="a"
          href={link}
          className={classNames(styles.button, styles[name.toLowerCase()])}
          icon={<ReactSVG src={icon} wrapper="span" />}
          size="m"
          target="_blank"
          rel="noopener noreferrer"
          fullWidth
        >
          {t('go_to', { platform: name })}
        </Button>
        <div className={styles.modalDescription}>
          Нет приложения на компьютере? Просто наведите камеру телефона на QR-код.
        </div>
        <Suspense fallback={<LoadingIndicator />}>
          <QRCode value={link} width={207} height={207} />
        </Suspense>
      </Modal>
    </>
  );
};

export default SocialModal;
